import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdVideoIcon } from './AdVideoIcon';
function PlusIcon() {
    return (_jsx("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round", children: _jsx("path", { d: "M12 5v14M5 12h14" }) }));
}
/**
 * Shared Shop/add-coins button. Module 103 (WP-103.1): a gold "+" nub that sits
 * INSIDE the coins capsule (`CurrencyDisplay`'s `coinsTrailing`), not a separate
 * green circle between Coins and Gems — a green "+" read as "buy", and on a host
 * with no purchases it opens a watch-an-ad top-up. The free-offer cue is a video
 * badge on the nub (the same `AdVideoIcon` every ad button carries), replacing the
 * red dot that, on a host where an ad is nearly always available, was never off.
 * `data-testid="shop-btn"` and the aria-label are unchanged, so every host and test
 * that finds the Shop by them still does.
 */
export function GameShopButton({ onClick, ariaLabel, className = 'game-shop-btn', hasFreeOffer = false, }) {
    return (_jsxs("button", { className: className, onClick: onClick, "aria-label": ariaLabel, "data-testid": "shop-btn", children: [_jsx(PlusIcon, {}), hasFreeOffer && (_jsx("span", { className: "game-shop-btn__ad", "aria-hidden": "true", "data-testid": "shop-btn-ad-badge", children: _jsx(AdVideoIcon, { size: 12 }) }))] }));
}
